import { render, staticRenderFns } from "./PromptCard.vue?vue&type=template&id=5e9ef806&scoped=true&"
import script from "./PromptCard.vue?vue&type=script&lang=js&"
export * from "./PromptCard.vue?vue&type=script&lang=js&"
import style0 from "./PromptCard.vue?vue&type=style&index=0&id=5e9ef806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9ef806",
  null
  
)

export default component.exports